import React, { useEffect, useState } from 'react';
import { MessageSquare } from 'lucide-react';
import { getMyWecomQr } from '../../../shared/api/wecom';

/**
 * 加老师微信 — a QR the parent scans to add our 企业微信 staff account. Hidden
 * until WeCom is configured on the server, and if the QR can't be made.
 */
export default function WecomSection() {
  const [qr, setQr] = useState(null);

  useEffect(() => {
    let alive = true;
    getMyWecomQr()
      .then((r) => { if (alive && r?.configured && r.qrCode) setQr(r); })
      .catch(() => { /* optional section */ });
    return () => { alive = false; };
  }, []);

  if (!qr) return null;
  return (
    <section className="settings-section settings-wecom" aria-label="加老师微信">
      <div className="settings-wecom__row">
        <div className="settings-wecom__info">
          <MessageSquare size={18} className="settings-wecom__icon" />
          <div>
            <div className="settings-wecom__label">加{qr.staffName || '老师'}微信</div>
            <div className="settings-wecom__hint">扫码添加，课程问题随时问，每周提醒</div>
          </div>
        </div>
        <img className="settings-wecom__qr" src={qr.qrCode} alt="企业微信二维码" width={96} height={96} loading="lazy" />
      </div>
    </section>
  );
}
